export default {
  state: {
    items: [],
  },
  getters: {
    items: (state) => state.items,
  },
  mutations: {
    add_item(state, { item_code, main_category, name }) {
      if (typeof main_category === 'object') {
        main_category = main_category.name;
      }
      main_category = main_category.toLowerCase();
      state.items.push({ item_code, main_category, name });
    },
    remove_item(state, { item_code }) {
      const index = _.findIndex(state.items, { 'item_code': item_code });
      if (index >= 0) {
        state.items.splice(index, 1);
      }
    },
    reset(state) {
      state.items = [];
    }
  },
  actions: {
    add({ commit }, payload) {
      commit('add_item', payload);
    },
    remove({ commit }, payload) {
      commit('remove_item', payload);
    },
    empty({ commit }) {
      commit('reset');
    }
  },
};
